import { useCallback, useEffect, useState } from "react";
import { PurchaseShell } from "../features/purchase/PurchaseShell";
import { useBranchScope } from "../features/purchase/branchScope";
import { ReportChips, NEEDS } from "../features/purchase/ReportChips";
import { ReportFilters } from "../features/purchase/ReportFilters";
import { ReportBody } from "../features/purchase/ReportBody";
import { runPurchaseReport } from "../api/purchases";

const today = () => new Date().toISOString().slice(0, 10);
const yearStart = () => `${today().slice(0, 4)}-01-01`;

export default function PurchaseReportsPage() {
  const { branchId } = useBranchScope();
  const [kind, setKind] = useState("period");
  const [filters, setFilters] = useState({ from_date: yearStart(), to_date: today(),
                                           as_of: today(), supplier_id: "" });
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);

  const params = useCallback(() => {
    const needs = NEEDS[kind] || [];
    const out = { branch_id: branchId || undefined };
    if (needs.includes("from_date")) out.from_date = filters.from_date;
    if (needs.includes("to_date")) out.to_date = filters.to_date;
    if (needs.includes("as_of")) out.as_of = filters.as_of;
    if (needs.includes("supplier")) out.supplier_id = filters.supplier_id || undefined;
    return out;
  }, [kind, filters, branchId]);

  const load = useCallback(() => {
    const query = params();
    if ((NEEDS[kind] || []).includes("supplier") && !query.supplier_id) {
      setData(null);
      return;
    }
    setBusy(true);
    runPurchaseReport(kind, query)
      .then(setData)
      .catch(() => setData(null))
      .finally(() => setBusy(false));
  }, [kind, params]);

  useEffect(() => { load(); }, [load]);

  return (
    <PurchaseShell titleKey="reports">
      <ReportChips value={kind} onChange={setKind} />
      <ReportFilters kind={kind} filters={filters} onChange={setFilters} />
      <ReportBody kind={kind} data={data} params={params()} onRefresh={load} busy={busy} />
    </PurchaseShell>
  );
}
